
// import React, { useEffect, useState } from "react";
// import { FaSpinner } from "react-icons/fa";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const GetLandDetails = () => {
//   const navigate = useNavigate();
//   const [lands, setLands] = useState([]);
//   const [filteredLands, setFilteredLands] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const [toastMessage, setToastMessage] = useState("");

//   const [cart, setCart] = useState(() => {
//     const savedCart = localStorage.getItem("cart");
//     return savedCart ? JSON.parse(savedCart) : [];
//   });

//   useEffect(() => {
//     const fetchLandDetails = async () => {
//       try {
//         const response = await axios.get(
//           "https://mnkymn9n.pythonanywhere.com/api/get_products_details"
//         );
//         setLands(response.data.reverse());
//         setFilteredLands(response.data.reverse());
//       } catch (error) {
//         console.error("Error fetching product details:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchLandDetails();
//   }, []);

//   useEffect(() => {
//     const filtered = lands.filter((land) =>
//       land.product_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       land.product_description.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     setFilteredLands(filtered);
//   }, [searchQuery, lands]);

//   useEffect(() => {
//     localStorage.setItem("cart", JSON.stringify(cart));
//   }, [cart]);

//   const showToast = (message) => {
//     setToastMessage(message);
//     setTimeout(() => setToastMessage(""), 3000);
//   };

//   const addToCart = (item) => {
//     const exists = cart.find((product) => product.product_id === item.product_id);
//     if (!exists) {
//       const updatedCart = [...cart, item];
//       setCart(updatedCart);
//       showToast("✅ Added to cart");
//     } else {
//       showToast("⚠️ Already in cart");
//     }
//   };

//   return (
//     <div className="container mt-4">
//       {/* Toast Notification */}
//       {toastMessage && (
//         <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1055 }}>
//           <div className="toast show bg-dark text-white shadow border-0">
//             <div className="toast-body">{toastMessage}</div>
//           </div>
//         </div>
//       )}

//       {/* Search Bar */}
//       <div className="row mb-4">
//         <div className="col-md-6 mx-auto">
//           <input
//             type="text"
//             className="form-control shadow-sm p-2"
//             placeholder="Search products..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </div>
//       </div>

//       {/* View Cart Button */}
//       <div className="text-end mb-3">
//         <button
//           className="btn btn-outline-success"
//           onClick={() => navigate("/cart")}
//         >
//           🛒 View Cart ({cart.length})
//         </button>
//       </div>

//       {/* Product List */}
//       {isLoading ? (
//         <div className="text-center my-5">
//           <FaSpinner className="text-primary" size={50} style={{ animation: "spin 1s linear infinite" }} />
//           <p>Loading products...</p>
//         </div>
//       ) : (
//         <div className="row">
//           {filteredLands.length > 0 ? (
//             filteredLands.map((land) => (
//               <div key={land.product_id} className="col-md-3 mb-4">
//                 <div className="card shadow-lg h-100">
//                   <img
//                     src={`https://mnkymn9n.pythonanywhere.com/static/images/${land?.product_photo}`}
//                     className="card-img-top"
//                     alt={land.product_description}
//                     style={{ height: "200px", objectFit: "contain" }}
//                   />
//                   <div className="card-body d-flex flex-column">
//                     <h5 className="card-title">{land?.product_name}</h5>
//                     <p className="card-text small flex-grow-1">
//                       {land.product_description.length > 50
//                         ? `${land.product_description.slice(0, 50)}...`
//                         : land.product_description}
//                     </p>
//                     <span className="text-success fw-bold">
//                       Ksh {land.product_cost.toLocaleString()}
//                     </span>

//                     <div className="mt-2 d-grid gap-2">
//                       <button
//                         className="btn btn-outline-primary"
//                         onClick={() => addToCart(land)}
//                       >
//                         Add to Cart
//                       </button>
//                       <button
//                         className="btn btn-dark"
//                         onClick={() => navigate('/makepayment', { state: { land } })}
//                       >
//                         Purchase Now
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="text-center text-muted">No products found.</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default GetLandDetails;



import React, { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const GetLandDetails = () => {
  const navigate = useNavigate();
  const [lands, setLands] = useState([]);
  const [filteredLands, setFilteredLands] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [toastMessage, setToastMessage] = useState("");
  const [visibleCount, setVisibleCount] = useState(8);
  const [filterOption, setFilterOption] = useState("default");

  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    const fetchLandDetails = async () => {
      try {
        const response = await axios.get(
          "https://mnkymn9n.pythonanywhere.com/api/get_products_details"
        );
        setLands(response.data.reverse());
        setFilteredLands(response.data.reverse());
      } catch (error) {
        console.error("Error fetching product details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLandDetails();
  }, []);

  useEffect(() => {
    let filtered = lands.filter((land) =>
      land.product_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      land.product_description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Sort logic
    if (filterOption === "lowToHigh") {
      filtered = filtered.sort((a, b) => a.product_cost - b.product_cost);
    } else if (filterOption === "highToLow") {
      filtered = filtered.sort((a, b) => b.product_cost - a.product_cost);
    }

    setFilteredLands(filtered);
    setVisibleCount(8); // Reset visible count on filter/search
  }, [searchQuery, lands, filterOption]);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 3000);
  };

  const addToCart = (item) => {
    const exists = cart.find((product) => product.product_id === item.product_id);
    if (!exists) {
      const updatedCart = [...cart, item];
      setCart(updatedCart);
      showToast("✅ Added to cart");
    } else {
      showToast("⚠️ Already in cart");
    }
  };

  return (
    <div className="container mt-4">
      {/* Toast Notification */}
      {toastMessage && (
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1055 }}>
          <div className="toast show bg-dark text-white shadow border-0">
            <div className="toast-body">{toastMessage}</div>
          </div>
        </div>
      )}

      {/* Search & Filter */}
      <div className="row mb-4">
        <div className="col-md-6 mb-2">
          <input
            type="text"
            className="form-control shadow-sm p-2"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="col-md-3 mb-2">
          <select
            className="form-select"
            value={filterOption}
            onChange={(e) => setFilterOption(e.target.value)}
          >
            <option value="default">Sort By</option>
            <option value="lowToHigh">Low to High Price</option>
            <option value="highToLow">High to Low Price</option>
          </select>
        </div>
        <div className="col-md-3 text-end mb-2">
          <button
            className="btn btn-outline-primary w-100"
            onClick={() => navigate("/cart")}
          >
            🛒 View Cart ({cart.length})
          </button>
        </div>
      </div>

      {/* Product List */}
      {isLoading ? (
        <div className="text-center my-5">
          <FaSpinner className="text-primary" size={50} style={{ animation: "spin 1s linear infinite" }} />
          <p>Loading products...</p>
        </div>
      ) : (
        <>
          <div className="row">
            {filteredLands.slice(0, visibleCount).map((land) => (
              <div key={land.product_id} className="col-md-3 mb-4">
                <div className="card shadow-lg h-100">
                  <img
                    src={`https://mnkymn9n.pythonanywhere.com/static/images/${land?.product_photo}`}
                    className="card-img-top"
                    alt={land.product_description}
                    style={{ height: "200px", objectFit: "contain" }}
                  />
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">{land?.product_name}</h5>
                    <p className="card-text small flex-grow-1">
                      {land.product_description.length > 50
                        ? `${land.product_description.slice(0, 50)}...`
                        : land.product_description}
                    </p>
                    <span className="text-success fw-bold">
                      Ksh {land.product_cost.toLocaleString()}
                    </span>

                    <div className="mt-2 d-grid gap-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => addToCart(land)}
                      >
                        Add to Cart
                      </button>
                      <button
                        className="btn btn-dark"
                        onClick={() => navigate("/makepayment", { state: { land } })}
                      >
                        Purchase Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Load More */}
          {visibleCount < filteredLands.length && (
            <div className="text-center mt-3">
              <button
                className="btn btn-outline-secondary"
                onClick={() => setVisibleCount(visibleCount + 8)}
              >
                Load More
              </button>
            </div>
          )}

          {filteredLands.length === 0 && (
            <div className="text-center text-muted">No products found.</div>
          )}
        </>
      )}
    </div>
  );
};

export default GetLandDetails;
